import React from 'react'
import "./Button.css"

const PrimaryBtn = ({ iconPosition = "left", label = "", handleClick = null, icon = null, px = "px-[20px]", py = "py-[10px]", disabled = false }) => {
    return (
        <button disabled={disabled} className={`disabled:cursor-not-allowed primaryBtn ${disabled ? "bg-[#B3B3B3]" : "bg-[#0068FF]"
            }  ${px} ${py}`} onClick={handleClick}>
            {icon && iconPosition === "left" && (
                <span className="flex items-center">{icon}</span>
            )}

            {label && <span className="!text-[#FFFFFF]">{label}</span>}

            {icon && iconPosition === "right" && (
                <span className="flex items-center">{icon}</span>
            )}

        </button>
    )
}

export default PrimaryBtn